var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 38206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.168 18.9517C23.7835 15.5472 23.1441 10.667 19.7396 8.05146C16.3352 5.43588 11.455 6.07536 8.83945 9.47979C6.22386 12.8842 6.86335 17.7644 10.2678 20.38C13.6722 22.9956 18.5524 22.3561 21.168 18.9517Z",
    fill: "#895E1A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.168 18.9517C23.7835 15.5472 23.1441 10.667 19.7396 8.05146C16.3352 5.43588 11.455 6.07536 8.83945 9.47979C6.22386 12.8842 6.86335 17.7644 10.2678 20.38C13.6722 22.9956 18.5524 22.3561 21.168 18.9517Z",
    fill: "#895E1A"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9807 17.243C21.6555 14.4921 20.7832 10.9044 18.0324 9.22952C15.2815 7.55468 11.6937 8.42698 10.0189 11.1779C8.34405 13.9287 9.21635 17.5165 11.9672 19.1913C14.7181 20.8662 18.3058 19.9939 19.9807 17.243Z",
    fill: "#895E1A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.1375 17.3488L12.6511 12.5432C12.554 12.2227 12.7329 11.9002 13.0504 11.7988L14.594 11.3218C15.601 11.0124 16.6617 11.5627 16.9695 12.5579C17.2772 13.5532 16.7075 14.5949 15.7035 14.9087L14.7332 15.2058L15.2871 16.9934C15.3841 17.3139 15.2008 17.6394 14.8877 17.7378C14.5672 17.8348 14.2346 17.6693 14.1375 17.3488ZM15.3568 13.7531C15.7022 13.6454 15.9213 13.2309 15.815 12.878C15.7087 12.5252 15.3065 12.3429 14.9566 12.4536L13.982 12.7537L14.3821 14.0532L15.3568 13.7531Z",
    fill: "url(#paint0_linear_844_14580)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.6292 12.7147C21.8059 8.50116 17.7228 5.75281 13.5093 6.57605C9.29582 7.3993 6.54746 11.4824 7.37071 15.6959C8.19396 19.9094 12.2771 22.6578 16.4906 21.8345C20.7041 21.0113 23.4524 16.9282 22.6292 12.7147Z",
    fill: "url(#paint1_linear_844_14580)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6292 12.7147C21.8059 8.50116 17.7228 5.75281 13.5093 6.57605C9.29582 7.3993 6.54746 11.4824 7.37071 15.6959C8.19396 19.9094 12.2771 22.6578 16.4906 21.8345C20.7041 21.0113 23.4524 16.9282 22.6292 12.7147Z",
    fill: "#895E1A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_844_14580",
    x1: 16.3183,
    y1: 17.4099,
    x2: 13.6834,
    y2: 8.87951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E88238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD16F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_844_14580",
    x1: 18.1451,
    y1: 24.3688,
    x2: 13.5363,
    y2: 9.4482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E88238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD16F",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.d019095be7b24ebd69f752fda82fd956.svg";
export { ForwardRef as ReactComponent };